import { v4 } from 'uuid';

class EventTargetPolyfill {
    constructor() {
        this.listeners = {};
    }
    addEventListener(type, callback) {
        if (!(type in this.listeners)) {
            this.listeners[type] = [];
        }
        this.listeners[type].push(callback);
    }
    removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
            return;
        }
        const stack = this.listeners[type];
        // tslint:disable-next-line one-variable-per-declaration
        for (let i = 0, l = stack.length; i < l; i++) {
            if (stack[i] === callback) {
                stack.splice(i, 1);
                return;
            }
        }
    }
    dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
            return true;
        }
        const stack = this.listeners[event.type].slice();
        // tslint:disable-next-line one-variable-per-declaration
        for (let i = 0, l = stack.length; i < l; i++) {
            stack[i].call(this, event);
        }
        return !event.defaultPrevented;
    }
}

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
class LarvaError extends Error {
    constructor(title, message, statusCode = 500, details = {}, stack) {
        super(title);
        this.type = 'LarvaError';
        this.error = this.title = title;
        this.message = message;
        this.statusCode = statusCode;
        this.details = details;
        this.stack = this.errors = stack;
    }
}

let WS;
if (typeof WebSocket !== 'undefined') {
    WS = WebSocket;
}
else if (typeof MozWebSocket !== 'undefined') {
    WS = MozWebSocket;
}
else if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    WS = window.WebSocket || window.MozWebSocket;
}
else if (typeof self !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    WS = self.WebSocket || self.MozWebSocket;
}
if (!WS) {
    throw new Error('WebsSckets not supported by this browser');
}
var WebSocket$1 = WS;

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
class LarvaWebsocket extends EventTargetPolyfill {
    constructor(token, options) {
        super();
        this.requests = {};
        this.timeouts = [];
        this.handleMessage = this.handleMessage.bind(this);
        this.socketClosed = this.socketClosed.bind(this);
        this.options = Object.assign({ timeout: 5000, openTimeout: 10000 }, options);
        if (!this.options.server) {
            throw new Error('No server supplied to LarvaWebsocket');
        }
        this.token = token;
        this.options.server = this.options.server.replace(/\/$/g, '');
        if (!this.options.server.startsWith('wss://') && !this.options.server.startsWith('ws://')) {
            throw new Error('Server must start with wss:// or ws://. Server:' + this.options.server);
        }
    }
    async open(url = this.options.server) {
        if (this.socket) {
            throw new Error('Already opening');
        }
        let timeoutId;
        await new Promise(async (resolve, reject) => {
            this.socket = new WebSocket$1(url);
            this.socket.onerror = (err) => reject(err);
            this.socket.onopen = () => {
                if (this.socket) {
                    clearTimeout(timeoutId);
                    this.socket.onerror = null;
                    this.socket.onclose = this.socketClosed;
                }
                resolve();
            };
            this.socket.onmessage = this.handleMessage;
            timeoutId = window.setTimeout(() => {
                this.close();
                console.error(`Openins socket Timeout Occured`);
                const err = new LarvaError('Timeout', 'Socket Connection timed out');
                reject(err);
            }, this.options.openTimeout);
        });
        this.dispatchEvent(new CustomEvent('open'));
    }
    async reconnect() {
        if (this.socket) {
            await this.close();
        }
        await this.open();
    }
    async close(reason = 1000) {
        var _a;
        // readyState: 0 CONNECTING, 1 OPEN, 2 CLOSING, 3 CLOSED
        if (((_a = this.socket) === null || _a === void 0 ? void 0 : _a.readyState) !== WebSocket$1.CLOSED) {
            await new Promise((resolve) => {
                var _a;
                this.socket.onmessage = null;
                this.socket.onopen = null;
                this.socket.onerror = null;
                this.socket.onclose = () => resolve();
                if (((_a = this.socket) === null || _a === void 0 ? void 0 : _a.readyState) !== WebSocket$1.CLOSING) {
                    this.socket.close(reason);
                }
            });
        }
        this.socket = undefined;
        this.clearAllPendingRequest();
        this.clearAllTimeouts();
    }
    addEventListener(event, listener) {
        super.addEventListener(event, listener);
    }
    removeEventListener(event, listener) {
        super.removeEventListener(event, listener);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async request(topic, data = {}) {
        const token = await this.getToken();
        const rsp = await this.rawRequest(topic, data, token);
        return rsp.payload.data;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async rawRequest(topic, data = {}, token) {
        let timeoutId;
        const body = this.requestBody(topic, data, token);
        const reqId = body.payload.reqId;
        return new Promise((resolve, reject) => {
            var _a;
            if (((_a = this.socket) === null || _a === void 0 ? void 0 : _a.readyState) !== WebSocket$1.OPEN) {
                console.error(new Error('Socket not opened'));
                return;
            }
            if (!topic) {
                return reject(new Error(`$larva.send param 'message' must include 'topic'`));
            }
            const bindedFn = (event) => {
                const obj = event && event.detail ? Object.assign({}, event.detail) : {};
                if (!obj.payload) {
                    obj.payload = {};
                }
                this.removePendingRequest(body.payload.reqId);
                this.clearTimeout(timeoutId);
                if (obj.topic === 'iot-2/evt/errors/fmt/json') {
                    if (!obj.payload.err) {
                        obj.payload.err = {};
                    }
                    const message = obj.payload.err.message ? obj.payload.err.message : 'Unknown error';
                    const title = obj.payload.err.error ? obj.payload.err.error : 'Error';
                    const statusCode = obj.payload.err.statusCode ? obj.payload.err.statusCode : 500;
                    const details = obj.payload.err.details ? obj.payload.err.details : {};
                    const deviceErr = new LarvaError(title, message, statusCode, details);
                    this.dispatchEvent(new CustomEvent('error', { detail: deviceErr }));
                    return reject(deviceErr);
                }
                resolve(obj);
            };
            timeoutId = window.setTimeout(() => {
                this.removePendingRequest(reqId);
                console.error(`Request Timeout Occured. Request id: ${reqId}`);
                if (this.socket) {
                    this.socket.removeEventListener(reqId, bindedFn);
                }
                const deviceErr = new LarvaError('Timeout', 'Request timed out', 408);
                reject(deviceErr);
            }, this.options.timeout);
            if (this.socket) {
                this.socket.addEventListener(reqId, bindedFn, { once: true });
                this.addPendingRequest(reqId);
                this.socket.send(JSON.stringify(body));
                this.timeouts.push(timeoutId);
            }
            else {
                this.clearTimeout(timeoutId);
                return reject(new Error('Socket not opened'));
            }
        });
    }
    readyState() {
        var _a, _b;
        return (_b = (_a = this.socket) === null || _a === void 0 ? void 0 : _a.readyState) !== null && _b !== void 0 ? _b : 3;
    }
    async getToken() {
        let tok = '';
        if (typeof this.token === 'function') {
            tok = await this.token();
        }
        else if (this.token) {
            tok = this.token;
        }
        return tok;
    }
    socketClosed() {
        this.dispatchEvent(new CustomEvent('closed', {}));
    }
    handleMessage(msg) {
        try {
            const detail = JSON.parse(msg.data);
            detail.payload = detail.payload || {};
            if (!detail.payload.reqId || (detail.payload.broadcast === true && !this.isRequestPending(detail.payload.reqId))) {
                const match = /^iot-2\/evt\/([^\/]+)\/fmt\/json$/g.exec(detail.topic);
                if (match) {
                    detail.evt = match[1];
                }
                this.dispatchEvent(new CustomEvent('broadcast', { detail }));
            }
            else if (this.socket) {
                if (this.isRequestPending(detail.payload.reqId)) {
                    this.socket.dispatchEvent(new CustomEvent(detail.payload.reqId, { detail }));
                }
            }
            else {
                console.warn('Ignoring websocket message', detail);
            }
        }
        catch (err) {
            console.error('Error parsing Larva Message', err);
        }
    }
    requestBody(topic, data, token) {
        const reqId = v4();
        const body = { topic, payload: { reqId, data, token } };
        return body;
    }
    addPendingRequest(id) {
        this.requests[id] = id;
    }
    removePendingRequest(id) {
        delete this.requests[id];
    }
    removeTimeoutId(id) {
        const index = this.timeouts.indexOf(id);
        if (index > -1) {
            this.timeouts.splice(index, 1);
        }
    }
    clearTimeout(id) {
        window.clearTimeout(id);
        this.removeTimeoutId(id);
    }
    clearAllTimeouts() {
        const timeoutsIs = [...this.timeouts];
        this.timeouts = [];
        for (const id of timeoutsIs) {
            this.clearTimeout(id);
        }
    }
    clearAllPendingRequest() {
        this.requests = {};
    }
    isRequestPending(id) {
        return !!this.requests[id];
    }
}

const DEFAULT_OPTIONS$1 = {
    server: 'ws://localhost',
    timeout: 5000,
    openTimeout: 10000,
};
class LarvaDevice extends LarvaWebsocket {
    constructor(unit, token, options) {
        super(token, Object.assign(Object.assign({}, DEFAULT_OPTIONS$1), options));
        this.handleNodeOutput = this.handleNodeOutput.bind(this);
        this.handleNodeRequest = this.handleNodeRequest.bind(this);
        this.options.server = this.options.server.replace(/\/$/g, '');
        if (!this.options.server.startsWith('wss://') && !this.options.server.startsWith('ws://')) {
            throw new Error('Server must start with wss:// or ws://. Server:' + this.options.server);
        }
        this.setUnit(unit);
    }
    async getUINodes(data) {
        const res = await this.request('iot-2/cmd/larvaUINodes/fmt/json', data);
        return res && res.nodes && Array.isArray(res.nodes) ? res.nodes : [];
    }
    async handleNodeOutput(event) {
        event.preventDefault(); // prevent event Bubbling
        event.stopPropagation(); // prevent event Bubbling
        const node = event.target;
        if (!node) {
            console.error('Handle node output received but no target element:', event);
            return;
        }
        const nodeId = this.getNodeId(event);
        return this.request(`iot-2/cmd/${nodeId}/fmt/json`, event.detail)
            .then((rsp) => {
            node.input(rsp);
        })
            .catch((err) => {
            node.error(err);
        });
    }
    async handleNodeRequest(event) {
        var _a;
        event.preventDefault(); // prevent event Bubbling
        event.stopPropagation(); // prevent event Bubbling
        const nodeId = this.getNodeId(event);
        const composedPath = event.composedPath();
        const subComponent = composedPath[0];
        const topic = event.detail.topic;
        let data = (_a = event.detail.payload) === null || _a === void 0 ? void 0 : _a.data;
        if (!topic || !event.detail.payload) {
            return subComponent.error('invalid request');
        }
        if (topic === 'iot-2/cmd/getNodeLogs/fmt/json') {
            data = Object.assign(Object.assign({}, data), { id: nodeId });
        }
        const token = await this.getToken();
        return this.rawRequest(topic, data, token)
            .then((rsp) => {
            console.warn('rsp', rsp);
            subComponent.response(rsp);
        })
            .catch((err) => {
            subComponent.error(err);
        });
    }
    getNodeId(data) {
        const node = data.target;
        if (!node) {
            throw new Error('Node target missing');
        }
        const nodeAattr = node.attributes.getNamedItem('node-id');
        const nodeId = nodeAattr ? nodeAattr.value : null;
        if (!nodeId) {
            const err = new Error('Node is missing node-id attribute');
            node.error(err);
            throw err;
        }
        return nodeId;
    }
    requestBody(topic, data, token) {
        const message = super.requestBody(topic, data, token);
        message.payload.unit = this.unit;
        return message;
    }
    setUnit(unit) {
        this.unit = unit;
    }
    getUnit() {
        return this.unit;
    }
    unsetUnit() {
        this.unit = undefined;
    }
}

const DEFAULT_OPTIONS = {
    server: 'wss://broker.larva.io',
    timeout: 5000,
    openTimeout: 10000,
};
/**
 * Connects to a LarvaDevice via cloud (broker)
 */
class Device extends LarvaDevice {
    constructor(deviceId, unit, token, options) {
        super(unit, token, Object.assign(Object.assign({}, DEFAULT_OPTIONS), options));
        if (!deviceId) {
            throw new Error('Missing deviceId');
        }
        this.deviceId = deviceId;
    }
    async open() {
        const query = [];
        const unit = this.getUnit();
        const token = await this.getToken();
        let url = `${this.options.server}/larva-device/${this.deviceId}`;
        if (unit) {
            query.push(`unit=${encodeURIComponent(unit)}`);
        }
        if (token) {
            query.push(`token=${encodeURIComponent(token)}`);
        }
        if (query.length > 0) {
            url += '?' + query.join('&');
        }
        return super.open(url);
    }
}

export { Device, LarvaDevice, LarvaError, LarvaWebsocket };
//# sourceMappingURL=index.esm.js.map
